import { Component, OnInit } from '@angular/core';

import { HeaderService } from '../../shared';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.scss']
})
export class InvoiceComponent implements OnInit {

  constructor( private headerService: HeaderService ) { }

  ngOnInit() {
    this.headerService.changeTitle('Notas fiscais');

    this.headerService.changeSubtitle('');

    this.headerService.changeDatePicker(false);
  }

}
